<section class="page-shell">
  <header class="page-header">
    <div class="left">
      <button mat-button routerLink="/dashboard"><mat-icon>arrow_back</mat-icon> Dashboard</button>
      <div class="title-block">
        <p class="eyebrow">Tasks</p>
      </div>
    </div>
    <div class="right">
      <button (click)="viewRunSheet()" class="ghost-btn run-sheet-btn" mat-stroked-button><mat-icon>assignment</mat-icon> Run sheet</button>
      <button type="button" (click)="openNewTaskDialog()" class="new-task-btn primary-btn" mat-raised-button color="primary"><mat-icon>add</mat-icon> New Task</button>
    </div>
  </header>

  <div class="controls">
    <div class="status-cards">
      <button type="button" class="status-card focus" [class.active]="activeTab=='active'" (click)="activateTab('active')">
        <p class="label">Active</p>
        <div class="value">{{activeCount}}</div>
        <p class="hint">Currently in progress</p>
      </button>
      <button type="button" class="status-card warning" [class.active]="showQueued" (click)="activateTab('queued')">
        <p class="label">Queued</p>
        <div class="value">{{queuedCount}}</div>
        <p class="hint">Assessed, waiting to start</p>
      </button>
      <button type="button" class="status-card pickup" [class.active]="activeTab=='pickup'" (click)="activateTab('pickup')">
        <p class="label">To be picked up</p>
        <div class="value">{{toBePickedUpCount}}</div>
        <p class="hint">Awaiting collection</p>
      </button>
      <button type="button" class="status-card success" [class.active]="activeTab=='completed'" (click)="activateTab('completed')">
        <p class="label">Completed</p>
        <div class="value">{{completedCount}}</div>
        <p class="hint">Marked done</p>
      </button>
    </div>
    <div class="meta">
      <ap-search class="search" placeholder="Search tasks" alignRight="true" (onChange)="search($event)" (cancelled)="searchCancelled()"></ap-search>
    </div>
  </div>

  <div class="stacked-wrapper" *ngIf="!isLoading && showQueued && queuedTasks?.length">
    <div class="group stacked queued-panel">
      <div class="group-heading">
        <div class="title">Queued</div>
        <div class="hint">{{queuedTasks.length}} queued to start</div>
      </div>
      <ng-container
        *ngTemplateOutlet="mobileTaskCards; context: {$implicit: queuedTaskAgeSections, taskList: queuedTasksDataSource?.filteredData || queuedTasks}">
      </ng-container>
      <ng-container
        *ngTemplateOutlet="desktopTaskSections; context: {$implicit: queuedTaskAgeSections, taskList: queuedTasksDataSource?.filteredData || queuedTasks}">
      </ng-container>
    </div>
  </div>


  <mat-spinner *ngIf="isLoading"></mat-spinner>

  <div class="table-card" *ngIf="!isLoading">
    <div class="group" *ngIf="focusedTasks?.length">
      <div class="group-heading">
        <div class="title">Focused</div>
        <div class="hint">{{focusedTasks.length}} marked for today</div>
      </div>
      <ng-container
        *ngTemplateOutlet="mobileTaskCards; context: {$implicit: focusedTaskAgeSections, taskList: focusedTasksDataSource?.filteredData || focusedTasks}">
      </ng-container>
      <ng-container
        *ngTemplateOutlet="desktopTaskSections; context: {$implicit: focusedTaskAgeSections, taskList: focusedTasksDataSource?.filteredData || focusedTasks, focused: true}">
      </ng-container>
    </div>

    <div class="group">
      <div class="group-heading">
        <div class="title">{{primaryGroupTitle}}</div>
        <div class="hint">{{primaryGroupHint}}</div>
      </div>
      <ng-container
        *ngTemplateOutlet="mobileTaskCards; context: {$implicit: activeTaskAgeSections, taskList: activeTasksDataSource?.filteredData || activeTasks}">
      </ng-container>
      <ng-container
        *ngTemplateOutlet="desktopTaskSections; context: {$implicit: activeTaskAgeSections, taskList: activeTasksDataSource?.filteredData || activeTasks}">
      </ng-container>
    </div>
  </div>

  <ng-template #desktopTaskSections let-sections let-taskList="taskList" let-focused="focused">
    <section class="task-age-section" *ngFor="let section of sections">
      <div class="task-age-divider" *ngIf="section.label">
        <span>{{section.label}}</span>
      </div>

      <div class="task-age-block">
        <table class="tasks" mat-table [dataSource]="section.tasks">
          <ng-container matColumnDef="taskNumber">
            <td
              class="number-column"
              mat-cell
              *matCellDef="let element"
              (click)="openTaskDialog(element, taskList.indexOf(element), taskList)">
              <div class="task-id"><span class="hash">#</span>{{element.id}}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="customer">
            <td
              class="customer-column"
              mat-cell
              *matCellDef="let element"
              (click)="openTaskDialog(element, taskList.indexOf(element), taskList)">
              <div class="customer-name" *ngIf="element.customer">{{element.customer?.name}}</div>
              <span class="muted" *ngIf="!element.customer">No customer</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="subject">
            <td
              class="subject-column"
              mat-cell
              *matCellDef="let element"
              (click)="openTaskDialog(element, taskList.indexOf(element), taskList)">
              <div class="subject-line">
                <span class="subject">{{element.subject}}</span>
                <span class="badge today" *ngIf="isToday(element)">{{focused ? 'Focused' : 'Today'}}</span>
                <span class="badge queued" *ngIf="element.status === TaskStatus.Queued">Queued</span>
                <span class="badge waiting-parts" *ngIf="element.waitingForParts">Waiting for Parts</span>
                <span class="badge pickup" *ngIf="isToBePickedUp(element)">To be picked up</span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="date">
            <td
              class="date-column"
              mat-cell
              *matCellDef="let element"
              (click)="openTaskDialog(element, taskList.indexOf(element), taskList)">
              <div class="date-chip">{{element.date | timeago}}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="action">
            <td class="action-column" mat-cell *matCellDef="let element">
              <div class="actions">
                <button
                  type="button"
                  class="pickup-btn"
                  mat-stroked-button
                  *ngIf="element.status !== TaskStatus.Completed"
                  (click)="toggleToBePickedUp(element)">
                  <mat-icon>{{isToBePickedUp(element) ? 'undo' : 'shopping_bag'}}</mat-icon>
                  {{isToBePickedUp(element) ? 'Return to active' : 'To be picked up'}}
                </button>
                <button class="complete-btn" mat-stroked-button (click)="completeTask(element)">Completed</button>
              </div>
            </td>
          </ng-container>

          <tr class="task-row" [class.isToday]="isToday(row)" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </section>
  </ng-template>

  <ng-template #mobileTaskCards let-sections let-taskList="taskList">
    <div class="mobile-task-list">
      <section class="mobile-age-section" *ngFor="let section of sections">
        <div class="mobile-age-divider" *ngIf="section.label">
          <span>{{section.label}}</span>
        </div>

        <div class="mobile-age-block">
          <article
            class="mobile-task-card"
            *ngFor="let task of section.tasks"
            [class.isToday]="isToday(task)"
            (click)="openTaskDialog(task, taskList.indexOf(task), taskList)">
            <div class="mobile-card-topline">
              <div class="task-id"><span class="hash">#</span>{{task.id}}</div>
              <div class="date-chip">{{task.date | timeago}}</div>
            </div>

            <h2>{{task.subject}}</h2>

            <div class="mobile-card-meta">
              <span class="customer-name" *ngIf="task.customer; else noMobileCustomer">{{task.customer?.name}}</span>
              <ng-template #noMobileCustomer><span class="muted">No customer</span></ng-template>
            </div>

            <div class="subject-line">
              <span class="badge today" *ngIf="isToday(task)">Today</span>
              <span class="badge queued" *ngIf="task.status === TaskStatus.Queued">Queued</span>
              <span class="badge waiting-parts" *ngIf="task.waitingForParts">Waiting for Parts</span>
              <span class="badge pickup" *ngIf="isToBePickedUp(task)">To be picked up</span>
            </div>

            <div class="mobile-card-actions">
              <button
                type="button"
                class="pickup-btn"
                mat-stroked-button
                *ngIf="task.status !== TaskStatus.Completed"
                (click)="$event.stopPropagation(); toggleToBePickedUp(task)">
                <mat-icon>{{isToBePickedUp(task) ? 'undo' : 'shopping_bag'}}</mat-icon>
                {{isToBePickedUp(task) ? 'Return to active' : 'To be picked up'}}
              </button>
              <button
                class="complete-btn"
                mat-stroked-button
                *ngIf="task.status !== TaskStatus.Completed"
                (click)="$event.stopPropagation(); completeTask(task)">
                Mark completed
              </button>
              <button
                mat-stroked-button
                color="primary"
                *ngIf="canTextCustomer(task)"
                (click)="$event.stopPropagation(); textCustomer(task, smsBodyJobCompleted(task))">
                Text cx repair complete
              </button>
              <button
                mat-stroked-button
                color="primary"
                *ngIf="canTextCustomer(task)"
                (click)="$event.stopPropagation(); textCustomer(task, smsBodyInvoiceAmount(task))">
                Text cx repair amount
              </button>
            </div>
          </article>
        </div>
      </section>
    </div>
  </ng-template>
</section>
